<script setup lang="ts">
/**
 * @author Beka Chkhaidze
 */

import { computed, ref, watch, onMounted } from "vue";
import type { ListDataInterface } from "@/types/ContentType";
import type { FAQCategory } from "@/store/main/types/widgets-terms/terms";

import Borders from "../../../regularComponents/UIComponents/Borders.vue";
import ChartItem from "./ChartItem.vue";

const props = defineProps<{
  SelectedTypeData: ListDataInterface;
  isTemplateRefInView?: boolean;
  activeType?: FAQCategory;
}>();

const templateRef = ref<HTMLDivElement>();
const templateKey = ref(0);

const widthsAndPrices = computed(() => {
  const prices = props.SelectedTypeData.tooltip?.map((el) => Number(el.amount) || 0);
  if (!prices?.length) return;

  const maxPrice = Math.max(...prices);

  const result = prices.map((price) => {
    const percentage = ((price / maxPrice) * 100).toFixed(2);
    return percentage;
  });

  return result;
});

watch(
  () => props.isTemplateRefInView,
  (n) => {
    if (n) {
      templateKey.value++;
    }
  }
);

watch(
  () => props.activeType,
  () => {
    templateKey.value++;
  }
);
</script>

<template>
  <div
    :class="['project-forecast__chart', { 'is-inview': isTemplateRefInView }]"
    ref="templateRef"
  >
    <div class="project-forecast__chart-items pos-rel">
      <Borders :count="8" :useContainerClass="false" removeLastBorder />
      <ul v-if="widthsAndPrices?.length && SelectedTypeData?.tooltip?.length">
        <ChartItem
          v-for="(item, index) in SelectedTypeData.tooltip"
          v-bind="{
            item,
            percentage: widthsAndPrices[index],
            delay: index * 250,
            key: index,
            templateKey,
          }"
        />
      </ul>
    </div>
  </div>
</template>
